// extracted by mini-css-extract-plugin
module.exports =  {"container":"_2787e5dfdf--container--RDF6a","text":"_2787e5dfdf--text--x93eI"};